import React from 'react';
import LetterTemplateList from './components/LetterTemplateList';

function LetterTemplatesPage() {
  return <LetterTemplateList />;
}

export default LetterTemplatesPage;
